'use client';
import { ButtonModal } from 'components/buttonModal/ButtonModal';
import Image from 'next/image';

interface BenefitCardProps {
  textAlignment?: 'left' | 'center' | 'right';
  title: string;
  description?: string;
  backgroundImage?: string;
  buttonMessage?: string;
  useDialog?: boolean;
  buttonLink?: string;
  children?: React.ReactNode;
  imagePosition?: 'center' | 'bottom' | 'top';
  direction?: 'left' | 'right';
}

export function BenefitCard(props: BenefitCardProps) {
  const {
    textAlignment,
    title,
    description,
    backgroundImage,
    buttonMessage,
    useDialog,
    buttonLink,
    direction,
    children,
    imagePosition = 'center'
  } = props;
  return (
    <div
      className={`flex w-full flex-col md:px-6 lg:flex-row lg:px-0 ${direction === 'left' ? 'lg:flex-row-reverse' : ''}`}
    >
      <div className="flex flex-1">
        <div className="w-full">
          <Image
            className="h-[20rem] rounded-xl md:h-[28rem]"
            width={1080}
            height={1080}
            src={backgroundImage || ''}
            alt={`${title} banner`}
            style={{ objectFit: 'cover', objectPosition: `${imagePosition} ${direction === 'left' ? 'right' : 'left'}`, width: '100%' }}
          />
        </div>
      </div>
      <div
        className={`z-10 mt-[-30px] flex flex-col justify-center gap-4 px-6 lg:mt-[0px] lg:max-w-[540px] lg:py-6 ${direction === 'left' ? 'lg:mr-[-10vw]' : 'lg:ml-[-10vw]'}`}
      >
        <div className={`flex flex-1 flex-col justify-center rounded-xl bg-white p-10 text-center`}>
          <h2 className={`text-lg font-bold md:text-2xl ${textAlignment === 'left' ? 'text-left' : textAlignment === 'right' ? 'text-right' : 'text-center'}`}>{title}</h2>
          <div
            className={`text-md mt-4 font-normal leading-5 ${textAlignment === 'left' ? 'text-left' : textAlignment === 'right' ? 'text-right' : 'text-center'}`} 
            dangerouslySetInnerHTML={{
              __html: description || ''
            }}
          />

          {!useDialog && !!buttonLink && (
            <div className="mt-4 flex justify-center">
              <a
                className="hover:text-fp-white rounded-lg border-2 border-fp-green bg-fp-green px-6 py-2 text-sm text-white hover:border-white hover:bg-fp-green hover:text-white"
                href={buttonLink}
              >
                {buttonMessage}
              </a>
            </div>
          )}

          {!!useDialog && (
            <div className="mt-4 flex justify-center">
              <ButtonModal size="4xl" variant="primary" text={buttonMessage}>
                <div className="flex w-full items-center justify-center">{children}</div>
              </ButtonModal>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
